import React from "react";

export const InputCheck = ({
  obj,
  headTitle,
  title,
  selectedSub,
  id,
  getInput,
  remove,
}) => {
  return (
    <div>
    <div className="checkBoxContainer">
      <label 
        className="container" 
        htmlFor={`defaultUnchecked${id}`}
        onChange={
          obj?.[selectedSub]?.[headTitle]
            ? obj[selectedSub][headTitle]?.indexOf(title) === -1
              ? () => getInput(headTitle, title, selectedSub)
              : () => remove(headTitle, title, selectedSub)
            : () => getInput(headTitle, title, selectedSub)
        }
        style={{
          fontSize:"16px",
          color:"#535252",
          paddingTop:"7px",
          marginRight:"28px"
        }}
        >
         {title}
        <input type="checkbox" 
          id={`defaultUnchecked${id}`}
          defaultChecked={
            obj?.[selectedSub]?.[headTitle]
              ? obj[selectedSub][headTitle]?.indexOf(title) !== -1
                ? true
                : false
              : false
          }
        />
        <span className="checkmark"></span>
      </label>
    </div>
    </div>
  );
};
